<div class="block-container">
  <h2>{{ "patient_access.title" | translate }}</h2>
  <p>{{ "patient_access.description" | translate }}</p>
  <a
    href="https://breathment.com/app"
    target="_blank"
    class="btn"
    (click)="handleLinkClick()"
  >
    {{ "patient_access.button" | translate }}
  </a>
</div>